module.exports = __webpack_public_path__ + "static/media/thumb.7f3e631b.jpg";